import types from './types';
import { ThunkDispatch } from "redux-thunk";
import api from 'constants/api';
import _get from "lodash/get";

export const getTempAuthNumber = (companyId: any) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.GET_TEMP_AUTH_NUMBER_REQUEST });

  return api.authorization.tempAuthNumber.get(companyId)
    .then((res: any) => {

      dispatch({
        type: types.GET_TEMP_AUTH_NUMBER_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Post failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_TEMP_AUTH_NUMBER_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const checkTempAuthNumber = (tempAuthNumber: any) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.CHECK_TEMP_AUTH_NUMBER_REQUEST });

  return api.authorization.tempAuthNumber.check(tempAuthNumber)
    .then((res: any) => {

      dispatch({
        type: types.CHECK_TEMP_AUTH_NUMBER_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.CHECK_TEMP_AUTH_NUMBER_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};
  